const steps = [
  { letter: "S", n: "01", title: "Structure", desc: "Cartographier, clarifier, formaliser. Voir l'organisation telle qu'elle est, sans complaisance." },
  { letter: "H", n: "02", title: "Harmonisation", desc: "Aligner vision, gouvernance et opérations. Faire converger ce qui se déclare et ce qui se fait." },
  { letter: "I", n: "03", title: "Indicateurs", desc: "Piloter par la donnée. Quitter l'arbitrage à l'instinct au profit du regard mesuré." },
  { letter: "N", n: "04", title: "Normalisation intelligente", desc: "Standardiser sans rigidifier. Un standard libère quand il est bien posé — il enferme sinon." },
  { letter: "R", n: "05", title: "Responsabilisation", desc: "Clarifier les rôles, développer l'autonomie. Chacun sait ce qu'il pilote — et ce qu'il décide." },
  { letter: "A", n: "06", title: "Autorité stratégique", desc: "Leadership stable et décisionnel. Le dirigeant retrouve son rôle : décider, arbitrer, protéger." },
];

const loopStep = {
  letter: "I",
  n: "07",
  title: "Itération continue",
  desc: "Amélioration permanente — Lean Management. La transformation ne s'arrête jamais : elle devient un mode de fonctionnement.",
};

export default function MethodTimeline() {
  return (
    <section id="parcours" className="bg-[#00224D] text-pearl py-24 sm:py-32 relative overflow-hidden grain" data-testid="method-timeline">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 items-end">
          <div className="md:col-span-3">
            <div className="font-mono-overline text-pearl/40 mb-3">La méthode</div>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight text-pearl" data-testid="method-title">
              SHINRAI. <em className="text-pearl/55 not-italic font-light">Sept temps pour une organisation pilotée.</em>
            </h2>
            <p className="mt-6 text-pearl/65 text-lg leading-relaxed max-w-3xl">
              Pas une méthode parmi d'autres — une <strong className="text-pearl">grammaire</strong>.
              Sept disciplines qui se renforcent mutuellement, du diagnostic structurel
              à l'amélioration continue. Chaque mission ShinRai mobilise les sept temps,
              dans le rythme adapté à ton organisation.
            </p>
          </div>
        </div>

        {/* First six steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-pearl/10">
          {steps.map((s, i) => (
            <div
              key={s.n}
              className="bg-[#00224D] p-8 lg:p-10 relative overflow-hidden group hover:bg-[#001533] transition-colors duration-500"
              data-testid={`method-step-${i + 1}`}
            >
              <span className="absolute -right-6 -bottom-12 font-serif text-[180px] text-pearl/5 leading-none select-none group-hover:text-pearl/10 transition">
                {s.letter}
              </span>
              <div className="relative">
                <div className="flex items-baseline gap-3 mb-4">
                  <span className="font-mono-overline text-gold">{s.n}</span>
                  <span className="h-px flex-1 bg-pearl/20" />
                </div>
                <h3 className="font-serif text-2xl mb-3 text-pearl leading-tight">{s.title}</h3>
                <p className="text-pearl/65 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Step 7 — Itération : full-width card. The big "I" completes the SHINRAI word read across the cards. */}
        <div
          className="mt-px bg-[#00224D] p-10 lg:p-14 relative overflow-hidden border-t border-gold/40 hover:bg-[#001533] transition-colors duration-500 group"
          data-testid="method-step-7"
        >
          {/* Big "I" watermark — same treatment as the other 6 cards */}
          <span className="absolute -right-6 -bottom-12 font-serif text-[180px] text-pearl/5 leading-none select-none group-hover:text-pearl/10 transition">
            {loopStep.letter}
          </span>
          <div className="relative max-w-3xl">
            <div className="flex items-baseline gap-3 mb-4">
              <span className="font-mono-overline text-gold inline-flex items-center gap-2">
                {/* Subtle loop accent next to label — signals the cyclical nature without competing with the letter */}
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M21 12a9 9 0 1 1-9-9c2.5 0 4.8 1 6.5 2.7L21 8" />
                  <polyline points="21 3 21 8 16 8" />
                </svg>
                {loopStep.n} · la boucle
              </span>
              <span className="h-px flex-1 bg-pearl/20" />
            </div>
            <h3 className="font-serif text-3xl sm:text-4xl mb-4 text-pearl leading-tight">
              {loopStep.title}
            </h3>
            <p className="text-pearl/65 text-base sm:text-lg leading-relaxed">{loopStep.desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
